import React from 'react'

const COPY_RIGHT = '©2021 by Photo Puzzle. Proudly created with Sikarin Poonsawat'

const Footer = () => {
  return (
    <div className="text-gray-500 text-sm text-center font-light mt-24 pb-14">
      {COPY_RIGHT}
    </div>
  )
}

export default Footer
